<div *ngIf="visible" class="alert alert-warning">
  <div style="font-size: small; font-weight: bold; text-transform: uppercase;">
      <ng-container *ngIf="environment === 'staging'">
        Staging
      </ng-container>
      <ng-container *ngIf="environment === 'development'">
        Development
      </ng-container>
  </div> 
  <ng-content></ng-content>
</div>